import React from 'react';

import type { IntlShape } from 'react-intl';

import { aiFailedStateMessages } from '@atlaskit/editor-common/ai-messages/ai-failed-state';
import Link from '@atlaskit/link/link';

export const getErrorMessage = (
	content: string,
): {
	defaultMessage: string;
	description: string;
	id: string;
} => {
	switch (content) {
		case 'INPUT_EXCEEDS_TOKEN_LIMIT':
			return aiFailedStateMessages.tokenLimitExceeded;
		case 'INPUT_TOO_SHORT_TO_SUMMARIZE':
			return aiFailedStateMessages.inputTooShortError;
		case 'INPUT_TOO_SHORT_TO_PROCESS':
			return aiFailedStateMessages.inputTooShortError;
		case 'RATE_LIMIT':
			return aiFailedStateMessages.rateLimitEnforced;
		case 'OPENAI_RATE_LIMIT_USER_ABUSE':
			return aiFailedStateMessages.rateLimitEnforced;
		case 'NO_AGENT':
			return aiFailedStateMessages.internalServerError;
		case 'FEATURE_DISABLED_ON_SITE':
			return aiFailedStateMessages.internalServerError;
		case 'FEATURE_DISABLED':
			return aiFailedStateMessages.internalServerError;
		case 'INTERNAL_SERVER_ERROR':
			return aiFailedStateMessages.internalServerError;
		case 'PLUGIN_ERRORED':
			return aiFailedStateMessages.internalServerError;
		case 'HIPAA_CONTENT_DETECTED':
			return aiFailedStateMessages.hipaaContentError;
		case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
			return aiFailedStateMessages.tokenLimitExceeded;
		default:
			return aiFailedStateMessages.apiError;
	}
};

export const getAupViolationMessage = (
	formatMessage: IntlShape['formatMessage'],
): React.ReactNode => {
	return formatMessage(aiFailedStateMessages.aupViolationMessage, {
		auplink: (chunks: React.ReactNode[]) => (
			<Link href="https://www.atlassian.com/legal/acceptable-use-policy" target="_blank">
				{chunks}
			</Link>
		), // Ignored via go/ees005
	});
};

export const getInternalServerErrorMessage = (
	formatMessage: IntlShape['formatMessage'],
): React.ReactNode => {
	return formatMessage(aiFailedStateMessages.internalServerError, {
		link: (chunks: React.ReactNode[]) => (
			<Link href="https://status.atlassian.com/" target="_blank">
				{chunks}
			</Link>
		), // Ignored via go/ees005
	});
};

export const getRateLimitErrorMessage = (
	formatMessage: IntlShape['formatMessage'],
): React.ReactNode => {
	return formatMessage(aiFailedStateMessages.rateLimitEnforced, {
		link: (chunks: React.ReactNode[]) => (
			<Link
				href="https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/"
				target="_blank"
			>
				{chunks}
			</Link>
		), // Ignored via go/ees005
	});
};
